"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _langtagUtils = require("@wapps/langtag-utils");

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Redirect = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Redirect, _PureComponent);

  var _super = _createSuper(Redirect);

  function Redirect() {
    var _this;

    (0, _classCallCheck2["default"])(this, Redirect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "perform", function () {
      var _this$props$pageConte = _this.props.pageContext,
          fallbackLng = _this$props$pageConte.fallbackLng,
          availableLngs = _this$props$pageConte.availableLngs,
          redirectPage = _this$props$pageConte.redirectPage;
      var detectedLng = window.localStorage.getItem('@wappsLng') || (0, _langtagUtils.lookup)(availableLngs, (0, _langtagUtils.navigatorLanguages)(), fallbackLng);
      window.localStorage.setItem('@wappsLng', detectedLng);
      var newUrl = (0, _gatsby.withPrefix)("/".concat(detectedLng).concat(redirectPage));
      (0, _gatsby.navigate)(newUrl, {
        replace: true
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Redirect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(0, _utils.isBrowser)()) this.perform();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Redirect;
}(_react.PureComponent);

var _default = Redirect;
exports["default"] = _default;